import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { IRequestG } from '../../../app/models/dtos/requestG.model';
import { IAprOutputData } from '../../../app/models/aprOutputData.model';
import { IResponseG } from '../../../app/models/dtos/responseG.model';
import { IAprInputData } from '../../../app/models/aprInputData.model';


@Injectable({
  providedIn: 'root'
})
export class CalculatorService {

  constructor(private http: HttpService) { }

  public getDataCalculatorPage(url: string, calDataGetReq: IRequestG<IAprInputData>): Observable<IResponseG<IAprOutputData>> {
    return this.http.post<IResponseG<IAprOutputData>, IRequestG<IAprInputData>>(url, calDataGetReq).pipe(
      catchError(this.handleError)
    );
  }
  private handleError(error: HttpErrorResponse): Observable<any> {
    console.error(error);
    return Observable.throw(error.message || 'Server error');
  }

}
